<script>
  export default {
    name: 'flat-carousel-item',

    data: () => ({
      imgMissing: false
    }),
    props: {
      allowHover: {
        type: Boolean,
        default: () => true
      },
      item: {
        type: Object,
        default: () => ({})
      },
      height: {
        type: String,
        default: () => ''
      },
      src: {
        type: String,
        default: () => ''
      }
    },
    methods: {
      onImageLoad(e) {
        if (e?.target?.naturalWidth <= 1) {
          this.imgMissing = true
        }
      }
    }
  }
</script>

<template>
  <v-hover v-slot="{ hover }">
    <v-card color="primary" height="100%" width="100%" flat rounded="lg" style="overflow: hidden" class="test">
      <v-sheet color="transparent" v-if="imgMissing && !hover" class="secondary--text font-weight-bold text-body-2 py-1 pl-2 text-truncate"> {{ item.title }}</v-sheet>
      <img id="t" height="100%" width="100%" :src="src" style="object-fit: cover; height: 100%; width: 100%" @load="onImageLoad" />
      <v-expand-transition>
        <div
          class="overlay d-flex flex-column align-start justify-start transition-fast-in-fast-out primary v-card--reveal cursor-arrow pa-2"
          :style="`height: ${allowHover && hover ? '100%' : '0%'}; opacity: ${allowHover && hover ? 1 : 0}; overflow-y: scroll`"
        >
          <a :href="item?.catalogUrl || ''" target="_blank" class="secondary--text font-weight-bold text-body-1 mb-0">
            {{ item.title }}
          </a>
          <p class="text-caption secondary--text">
            {{ Array.isArray(item?.authors) ? item?.authors?.[0] : item?.authors || '' }}
          </p>
          <p v-html="item?.description || ''" class="text-caption secondary--text"></p>
        </div>
      </v-expand-transition>
    </v-card>
  </v-hover>
</template>

<style scoped>
  .v-card--reveal {
    align-items: center;
    bottom: 0;
    justify-content: center;
    opacity: 0.85;
    position: absolute;
    width: 100%;
  }

  .test {
    border: none !important;
    background-image: url('https://media.eipl.org/site/images/logos/eipl-square.jpg');
    background-position: center;
    background-size: 50%;
    border-radius: 5px;
    border-color: rgba(0, 0, 0, 0.4);
    border-color: var(--v-primary-base);
    border-style: solid;
    /* background-size: cover; */
    background-color: var(--v-primary-base);
    object-fit: cover;
    /* background-color: #ccc; */
    display: block;
    margin: 0;
    box-sizing: border-box;
    text-align: left;
  }
</style>
